import { render, staticRenderFns } from "./Rack.vue?vue&type=template&id=0b67ba20&"
import script from "./Rack.vue?vue&type=script&lang=js&"
export * from "./Rack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports